import {fsa, fsaError, fsaPayload, fsaPayloadByKeys} from './helpers'

/**
 * RTK Flow Actions
 */
export const START_RTK_FLOW = 'start RTK flow'
export const startRentToKeepFlow = fsaPayloadByKeys(START_RTK_FLOW, ['eventId'])

export const SUBMIT_SELECT_ITEMS = 'submits the selected items to purchase for RTK'
export const submitSelectItems = fsaPayload(SUBMIT_SELECT_ITEMS)

export const SUBMIT_BILLING_STEP = 'submits the billing step for RTK'
export const submitBillingStep = fsa(SUBMIT_BILLING_STEP)

export const SUBMIT_CHARGE_CARD_ON_FILE = 'submits charging card on file for RTK'
export const submitChargeCardOnFile = fsa(SUBMIT_CHARGE_CARD_ON_FILE)

/**
 * GET eligible Rent-to-Keep items API actions
 */
export const GET_ELIGIBLE_RTK_ITEMS = 'get eligible RTK items'
export const getEligibleRTKItems = fsaPayloadByKeys(GET_ELIGIBLE_RTK_ITEMS, ['eventId'])

export const GET_ELIGIBLE_RTK_ITEMS_PENDING = 'get eligible RTK items pending'
export const getEligibleRTKItemsPending = fsa(GET_ELIGIBLE_RTK_ITEMS_PENDING)

export const GET_ELIGIBLE_RTK_ITEMS_SUCCESS = 'get eligible RTK items successful'
export const getEligibleRTKItemsSuccess = fsaPayload(GET_ELIGIBLE_RTK_ITEMS_SUCCESS)

export const GET_ELIGIBLE_RTK_ITEMS_FAILURE = 'get eligible RTK items failed'
export const getEligibleRTKItemsFailure = fsaError(GET_ELIGIBLE_RTK_ITEMS_FAILURE)

/**
 * POST save billing address API actions
 */
export const SAVE_RTK_BILLING_INFORMATION_PENDING = 'save RTK billing information pending'
export const saveRTKBillingInformationPending = fsa(SAVE_RTK_BILLING_INFORMATION_PENDING)

export const SAVE_RTK_BILLING_INFORMATION_SUCCESS = 'save RTK billing information successful'
export const saveRTKBillingInformationSuccess = fsa(SAVE_RTK_BILLING_INFORMATION_SUCCESS)

export const SAVE_RTK_BILLING_INFORMATION_FAILURE = 'save RTK billing information failed'
export const saveRTKBillingInformationFailure = fsaError(SAVE_RTK_BILLING_INFORMATION_FAILURE)

/**
 * GET Rent-to-keep order summary totals
 */
export const CALCULATE_RTK_ORDER_TOTALS = 'calculate RTK order summary totals'
export const calculateRTKOrderTotals = fsaPayload(CALCULATE_RTK_ORDER_TOTALS)

export const CALCULATE_RTK_ORDER_TOTALS_PENDING = 'calculate RTK order summary totals pending'
export const calculateRTKOrderTotalsPending = fsa(CALCULATE_RTK_ORDER_TOTALS_PENDING)

export const CALCULATE_RTK_ORDER_TOTALS_SUCCESS = 'calculate RTK order summary totals success'
export const calculateRTKOrderTotalsSuccess = fsaPayload(CALCULATE_RTK_ORDER_TOTALS_SUCCESS)

export const CALCULATE_RTK_ORDER_TOTALS_FAILURE = 'calculate RTK order summary totals failure'
export const calculateRTKOrderTotalsFailure = fsaError(CALCULATE_RTK_ORDER_TOTALS_FAILURE)

/**
 * Actions to purchase Rent-to-Keep Selected Items
 */
export const SUBMIT_RTK_PURCHASE = 'submit purchase for RTK'
export const submitRTKPurchase = fsa(SUBMIT_RTK_PURCHASE)

export const SUBMIT_RTK_PURCHASE_PENDING = 'submit RTK purchase pending'
export const submitRTKPurchasePending = fsa(SUBMIT_RTK_PURCHASE_PENDING)

export const SUBMIT_RTK_PURCHASE_SUCCESS = 'submit RTK purchase success'
export const submitRTKPurchaseSuccess = fsa(SUBMIT_RTK_PURCHASE_SUCCESS)

export const SUBMIT_RTK_PURCHASE_FAILURE = 'submit RTK purchase failed'
export const submitRTKPurchaseFailure = fsaError(SUBMIT_RTK_PURCHASE_FAILURE)
